<template>
    <el-select
        class="no-select w-full"
        filterable
        clearable
        remote
        v-model="selected_line"
        :disabled="disabled"
        :placeholder="placeholder"
        :loading="is_fetching_lines"
        :remote-method="fetchLines"
        @change="changeTargetLine"
    >
        <el-option
            v-for="line in linesAlphabeticalOrder"
            class="p-0"
            :key="line.id"
            :label="cleanupDeletedTag(line.name)"
            :value="line.id">
            <div>
                <p class="mb-0">
                    <span class="font-weight-bold">Line:</span> #{{ line.id }} {{ cleanupDeletedTag(line.name) }}
                </p>
                <!-- Phone Number Matches -->
                <span v-if="hasPhoneMatches(line)" class="mb-0">
                    <span class="font-weight-bold">Phone Number:</span> {{ (getFirstPhoneMatch(line)) }}
                </span>
                <span v-if="hasExtraPhoneMatches(line)" class="label ml-1">+ {{ phoneMatchesCount(line) - 1 }}</span>
            </div>
        </el-option>
    </el-select>
</template>

<script>
import { format_mixin, search_mixin } from '../mixins'

export default {
    mixins: [format_mixin, search_mixin],

    props: {
        value: {
            required: true
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Search a line by ID, name or phone number'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        except: {
           required: false,
           type: Array,
            default: () => []
        },
        company_id: {
            required: false,
            default: null
        },
        porting: {
            type: Boolean,
            required: false,
            default: false
        },
        phone_number_search: {
            type: String,
            required: false,
            default: ''
        },
    },

    data() {
        return {
            selected_line: null,
            lines: [],
            is_fetching_lines: false,
            search_criteria: '',
            CancelToken: null,
            source: null,
        }
    },

    watch: {
        value(val) {
            this.selected_line = val
        },
        company_id(val) {
            // Reset lines when company changes and wait for the search
            this.lines = []
            this.selected_line = null
        }
    },

    computed: {
        linesAlphabeticalOrder() {
            if (this.lines.length === 0) {
                return []
            }
            
            const lines = this.except.length > 0 ? _.clone(this.linesExceptExcluded) : _.clone(this.lines)
            return lines.sort((a, b) => {
                let textA = a.name.toUpperCase()
                let textB = b.name.toUpperCase()
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
            })
        },

        linesExceptExcluded() {
            return this.lines.filter(c => !this.except.includes(c.id))
        }
    },

    created() {
        this.CancelToken = axios.CancelToken
        this.source = this.CancelToken.source()
    },

    methods: {
        getFirstPhoneMatch(line) {
            if (line && line.incoming_numbers) {
                // Match the phone number with the search text
                const phone_numbers = this.searchPhoneNumbers(line.incoming_numbers, this.search_criteria)

                if (phone_numbers.length > 0) {
                    return this.cleanupDeletedTag(phone_numbers[0].phone_number)
                }
            }

            return ''
        },
        phoneMatchesCount(line) {
            if (!line.incoming_numbers) {
                return 0
            }

            // Match the phone number with the search text
            const phone_numbers = this.searchPhoneNumbers(line.incoming_numbers, this.search_criteria)

            return phone_numbers.length
        },
        hasPhoneMatches(line) {
            return this.phoneMatchesCount(line) > 0
        },
        hasExtraPhoneMatches(line) {
            return this.phoneMatchesCount(line) > 1
        },
        fetchLines(text) {
            this.search_criteria = text
            if (Number.isInteger(parseInt(text)) || text.length >= 3) {
                this.source.cancel('fetchLines canceled by the user.')
                this.source = this.CancelToken.source()
                this.is_fetching_lines = true
                const query = {
                    search_text: text,
                    incoming_number_search: true,
                    porting: this.porting
                }
                axios.get(`/api/admin/company/${this.company_id}/campaigns`, {
                    params: query,
                    cancelToken: this.source.token
                }).then((res) => {
                    this.is_fetching_lines = false
                    this.lines = res.data
                }).catch((err) => {
                    if (axios.isCancel(err)) {
                        console.log('Request canceled', err.message)
                    } else {
                        this.$root.handleErrors(err.response)
                        this.is_fetching_lines = false
                    }
                })
            } else {
                this.lines = []
            }
        },

        changeTargetLine(line_id) {
            this.$emit('input', line_id)

            const line = this.lines.find(line => parseInt(line.id) === parseInt(line_id))

            if (line) {
                this.$emit('input-label', line.name)
            }
        }
    },
}
</script>
